import React, { useState, useEffect, useMemo, useRef } from 'react';
import { Card, Select, Tabs, Badge, Statistic, Row, Col } from 'antd';
import { UserOutlined, GlobalOutlined, RiseOutlined, BookOutlined } from '@ant-design/icons';
import MaterialTable from 'material-table';
import ForumIcon from '@mui/icons-material/Forum';
import { GetCousesOfInstructror, StudentsEnrolled } from '../../../api';

const { Option } = Select;
const { TabPane } = Tabs;

// Coordinate mapping for countries
const COUNTRY_COORDINATES = {
  'Afghanistan': { lat: 33.9391, lng: 67.7100 },
  'Albania': { lat: 41.1533, lng: 20.1683 },
  'Algeria': { lat: 28.0339, lng: 1.6596 },
  'Andorra': { lat: 42.5078, lng: 1.5211 },
  'Angola': { lat: -11.2027, lng: 17.8739 },
  'Antigua and Barbuda': { lat: 17.0608, lng: -61.7964 },
  'Argentina': { lat: -38.4161, lng: -63.6167 },
  'Armenia': { lat: 40.0691, lng: 45.0382 },
  'Australia': { lat: -25.2744, lng: 133.7751 },
  'Austria': { lat: 47.5162, lng: 14.5501 },
  'Azerbaijan': { lat: 40.1431, lng: 47.5769 },
  'Bahamas': { lat: 25.0343, lng: -77.3963 },
  'Bahrain': { lat: 25.9304, lng: 50.6378 },
  'Bangladesh': { lat: 23.6850, lng: 90.3563 },
  'Barbados': { lat: 13.1939, lng: -59.5432 },
  'Belarus': { lat: 53.7098, lng: 27.9534 },
  'Belgium': { lat: 50.8503, lng: 4.3517 },
  'Belize': { lat: 17.1899, lng: -88.4976 },
  'Benin': { lat: 9.3075, lng: 2.3158 },
  'Bhutan': { lat: 27.5142, lng: 90.4336 },
  'Bolivia': { lat: -16.2902, lng: -63.5887 },
  'Bosnia and Herzegovina': { lat: 43.9159, lng: 17.6791 },
  'Botswana': { lat: -22.3285, lng: 24.6849 },
  'Brazil': { lat: -14.2350, lng: -51.9253 },
  'Brunei': { lat: 4.5353, lng: 114.7277 },
  'Bulgaria': { lat: 42.7339, lng: 25.4858 },
  'Burkina Faso': { lat: 12.2383, lng: -1.5616 },
  'Burundi': { lat: -3.3731, lng: 29.9189 },
  'Cabo Verde': { lat: 16.5388, lng: -23.0418 },
  'Cambodia': { lat: 12.5657, lng: 104.9910 },
  'Cameroon': { lat: 3.8480, lng: 11.5021 },
  'Canada': { lat: 56.1304, lng: -106.3468 },
  'Central African Republic': { lat: 6.6111, lng: 20.9394 },
  'Chad': { lat: 15.4542, lng: 18.7322 },
  'Chile': { lat: -35.6751, lng: -71.5430 },
  'China': { lat: 35.8617, lng: 104.1954 },
  'Colombia': { lat: 4.5709, lng: -74.2973 },
  'Comoros': { lat: -11.8750, lng: 43.8722 },
  'Congo (Congo-Brazzaville)': { lat: -0.2280, lng: 15.8277 },
  'Congo (Democratic Republic of the Congo)': { lat: -4.0383, lng: 21.7587 },
  'Costa Rica': { lat: 9.7489, lng: -83.7534 },
  'Croatia': { lat: 45.1, lng: 15.2 },
  'Cuba': { lat: 21.5218, lng: -77.7812 },
  'Cyprus': { lat: 35.1264, lng: 33.4299 },
  'Czech Republic': { lat: 49.8175, lng: 15.4720 },
  'Denmark': { lat: 56.2639, lng: 9.5018 },
  'Djibouti': { lat: 11.8251, lng: 42.5903 },
  'Dominica': { lat: 15.4148, lng: -61.3700 },
  'Dominican Republic': { lat: 18.7357, lng: -70.1627 },
  'Ecuador': { lat: -1.8312, lng: -78.1834 },
  'Egypt': { lat: 26.8206, lng: 30.8025 },
  'El Salvador': { lat: 13.7942, lng: -88.8965 },
  'Equatorial Guinea': { lat: 1.6508, lng: 10.2679 },
  'Eritrea': { lat: 15.1794, lng: 39.7823 },
  'Estonia': { lat: 58.5953, lng: 25.0136 },
  'Eswatini': { lat: -26.5225, lng: 31.4659 },
  'Ethiopia': { lat: 9.145, lng: 40.4897 },
  'Fiji': { lat: -17.7134, lng: 178.0650 },
  'Finland': { lat: 61.9241, lng: 25.7482 },
  'France': { lat: 46.2276, lng: 2.2137 },
  'Gabon': { lat: -0.8037, lng: 11.6094 },
  'Gambia': { lat: 13.4432, lng: -15.3101 },
  'Georgia': { lat: 42.3154, lng: 43.3569 },
  'Germany': { lat: 51.1657, lng: 10.4515 },
  'Ghana': { lat: 7.9465, lng: -1.0232 },
  'Greece': { lat: 39.0742, lng: 21.8243 },
  'Grenada': { lat: 12.2628, lng: -61.6042 },
  'Guatemala': { lat: 15.7835, lng: -90.2308 },
  'Guinea': { lat: 9.9456, lng: -9.6966 },
  'Guinea-Bissau': { lat: 11.8037, lng: -15.1804 },
  'Guyana': { lat: 4.8604, lng: -58.9302 },
  'Haiti': { lat: 18.9712, lng: -72.2852 },
  'Honduras': { lat: 13.9094, lng: -83.9510 },
  'Hungary': { lat: 47.1625, lng: 19.5033 },
  'Iceland': { lat: 64.9631, lng: -19.0208 },
  'India': { lat: 20.5937, lng: 78.9629 },
  'Indonesia': { lat: -0.7893, lng: 113.9213 },
  'Iran': { lat: 32.4279, lng: 53.6880 },
  'Iraq': { lat: 33.2232, lng: 43.6793 },
  'Ireland': { lat: 53.1424, lng: -7.6921 },
  'Israel': { lat: 31.0461, lng: 34.8516 },
  'Italy': { lat: 41.8719, lng: 12.5674 },
  'Jamaica': { lat: 18.1096, lng: -77.2975 },
  'Japan': { lat: 36.2048, lng: 138.2529 },
  'Jordan': { lat: 30.5852, lng: 36.2384 },
  'Kazakhstan': { lat: 48.0196, lng: 66.9237 },
  'Kenya': { lat: -1.2921, lng: 36.8219 },
  'Kiribati': { lat: -3.3704, lng: -168.7340 },
  'North Korea': { lat: 40.3399, lng: 127.5101 },
  'South Korea': { lat: 35.9078, lng: 127.7669 },
  'Kuwait': { lat: 29.3759, lng: 47.9774 },
  'Kyrgyzstan': { lat: 41.2044, lng: 74.7661 },
  'Laos': { lat: 19.8563, lng: 102.4955 },
  'Latvia': { lat: 56.8796, lng: 24.6032 },
  'Lebanon': { lat: 33.8547, lng: 35.8623 },
  'Lesotho': { lat: -29.6093, lng: 28.2336 },
  'Liberia': { lat: 6.4281, lng: -9.4295 },
  'Libya': { lat: 26.3351, lng: 17.2283 },
  'Liechtenstein': { lat: 47.1415, lng: 9.5215 },
  'Lithuania': { lat: 55.1694, lng: 23.8813 },
  'Luxembourg': { lat: 49.6117, lng: 6.13 },
  'Madagascar': { lat: -18.7669, lng: 46.8691 },
  'Malawi': { lat: -13.2543, lng: 34.3015 },
  'Malaysia': { lat: 4.2105, lng: 101.9758 },
  'Maldives': { lat: 3.2028, lng: 73.2207 },
  'Mali': { lat: 17.5707, lng: -3.9962 },
  'Malta': { lat: 35.9375, lng: 14.3754 },
  'Marshall Islands': { lat: 7.1315, lng: 171.1845 },
  'Mauritania': { lat: 21.0079, lng: -10.9400 },
  'Mauritius': { lat: -20.3484, lng: 57.5522 },
  'Mexico': { lat: 23.6345, lng: -102.5528 },
  'Micronesia': { lat: 7.4256, lng: 150.5508 },
  'Moldova': { lat: 47.4116, lng: 28.3699 },
  'Monaco': { lat: 43.7333, lng: 7.4167 },
  'Mongolia': { lat: 46.8625, lng: 103.8467 },
  'Montenegro': { lat: 42.7087, lng: 19.3744 },
  'Morocco': { lat: 31.7917, lng: -7.0926 },
  'Mozambique': { lat: -18.6657, lng: 35.5296 },
  'Myanmar': { lat: 21.9139, lng: 95.9560 },
  'Namibia': { lat: -22.9576, lng: 18.4904 },
  'Nauru': { lat: -0.5228, lng: 166.9315 },
  'Nepal': { lat: 28.3949, lng: 84.1240 },
  'Netherlands': { lat: 52.1326, lng: 5.2913 },
  'New Zealand': { lat: -40.9006, lng: 174.8860 },
  'Nicaragua': { lat: 12.8654, lng: -85.2072 },
  'Niger': { lat: 17.6078, lng: 8.0817 },
  'Nigeria': { lat: 9.0820, lng: 8.6753 },
  'North Macedonia': { lat: 41.6086, lng: 21.7453 },
  'Norway': { lat: 60.4720, lng: 8.4689 },
  'Oman': { lat: 21.5126, lng: 55.9233 },
  'Pakistan': { lat: 30.3753, lng: 69.3451 },
  'Palau': { lat: 7.5149, lng: 134.5825 },
  'Panama': { lat: 8.5380, lng: -80.7821 },
  'Papua New Guinea': { lat: -6.3149, lng: 143.9555 },
  'Paraguay': { lat: -23.4425, lng: -58.4438 },
  'Peru': { lat: -9.1900, lng: -75.0152 },
  'Philippines': { lat: 12.8797, lng: 121.7740 },
  'Poland': { lat: 51.9194, lng: 19.1451 },
  'Portugal': { lat: 39.3999, lng: -8.2245 },
  'Qatar': { lat: 25.3548, lng: 51.1839 },
  'Romania': { lat: 45.9432, lng: 24.9668 },
  'Russia': { lat: 55.7558, lng: 37.6176 },
  'Rwanda': { lat: -1.9403, lng: 29.8739 },
  'Saint Kitts and Nevis': { lat: 17.3578, lng: -62.7825 },
  'Saint Lucia': { lat: 13.9094, lng: -60.9789 },
  'Saint Vincent and the Grenadines': { lat: 12.9843, lng: -61.2872 },
  'Samoa': { lat: -13.7590, lng: -172.1046 },
  'San Marino': { lat: 43.9333, lng: 12.45 },
  'Sao Tome and Principe': { lat: 0.1864, lng: 6.6131 },
  'Saudi Arabia': { lat: 23.8859, lng: 45.0792 },
  'Senegal': { lat: 14.6928, lng: -17.4467 },
  'Serbia': { lat: 44.0165, lng: 21.0059 },
  'Seychelles': { lat: -4.6796, lng: 55.4920 },
  'Sierra Leone': { lat: 8.4600, lng: -11.7793 },
  'Singapore': { lat: 1.3521, lng: 103.8198 },
  'Slovakia': { lat: 48.6690, lng: 19.6990 },
  'Slovenia': { lat: 46.1511, lng: 14.9955 },
  'Solomon Islands': { lat: -29.6249, lng: 153.1039 },
  'Somalia': { lat: 5.1521, lng: 46.1996 },
  'South Africa': { lat: -30.5595, lng: 22.9375 },
  'South Sudan': { lat: 6.8777, lng: 31.3070 },
  'Spain': { lat: 40.4637, lng: -3.7492 },
  'Sri Lanka': { lat: 7.8750, lng: 80.7718 },
  'Sudan': { lat: 12.8628, lng: 30.2176 },
  'Suriname': { lat: 3.9196, lng: -56.0278 },
  'Sweden': { lat: 60.1282, lng: 18.6435 },
  'Switzerland': { lat: 46.8182, lng: 8.2275 },
  'Syria': { lat: 34.8021, lng: 38.9968 },
  'Taiwan': { lat: 23.6978, lng: 120.9605 },
  'Tajikistan': { lat: 38.8610, lng: 71.2761 },
  'Tanzania': { lat: -6.369028, lng: 34.888822 },
  'Thailand': { lat: 15.8700, lng: 100.9925 },
  'Timor-Leste': { lat: -8.8742, lng: 125.7275 },
  'Togo': { lat: 8.6195, lng: 0.8248 },
  'Tonga': { lat: -21.1789, lng: -175.1982 },
  'Trinidad and Tobago': { lat: 10.6918, lng: -61.2225 },
  'Tunisia': { lat: 33.8869, lng: 9.5375 },
  'Turkey': { lat: 38.9637, lng: 35.2433 },
  'Turkmenistan': { lat: 38.9697, lng: 59.5563 },
  'Tuvalu': { lat: -7.1095, lng: 179.1940 },
  'Uganda': { lat: 1.3733, lng: 32.2903 },
  'Ukraine': { lat: 48.3794, lng: 31.1656 },
  'United Arab Emirates': { lat: 23.4241, lng: 53.8478 },
  'United Kingdom': { lat: 55.3781, lng: -3.4360 },
  'United States': { lat: 37.0902, lng: -95.7129 },
  'Uruguay': { lat: -32.9655, lng: -56.1910 },
  'Uzbekistan': { lat: 41.3775, lng: 64.5853 },
  'Vanuatu': { lat: -15.3767, lng: 166.9592 },
  'Vatican City': { lat: 41.9029, lng: 12.4534 },
  'Venezuela': { lat: 6.4238, lng: -66.5897 },
  'Vietnam': { lat: 14.0583, lng: 108.2772 },
  'Yemen': { lat: 15.5520, lng: 48.5164 },
  'Zambia': { lat: -13.1339, lng: 27.8493 },
  'Zimbabwe': { lat: -19.0154, lng: 29.1549 }
};

// 1. ADDED: Predefined palette for distinct colors
const COUNTRY_COLORS = [
    '#FF6633', '#FFB399', '#FF33FF', '#FFFF99', '#00B3E6',
    '#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D',
    '#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A',
    '#FF99E6', '#CCFF1A', '#FF1A66', '#E6331A', '#33FFCC',
    '#66994D', '#B366CC', '#4D8000', '#B33300', '#CC80CC',
    '#66664D', '#991A1A', '#E666FF', '#4DB3FF', '#1AB399',
    '#E666B3', '#33991A', '#CC9999', '#B3B31A', '#00E680',
    '#4D8066', '#809980', '#E6FF80', '#1AFF33', '#999933',
    '#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3',
    '#E64D66', '#4DB380', '#FF4D4D', '#99E6E6', '#6666FF'
];

// 2. ADDED: Hashing function to consistently assign the same color to the same country
const hashCode = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = (hash << 5) - hash + str.charCodeAt(i);
        hash |= 0;
    }
    return hash;
};

const getUniqueColor = (countryName) => {
    const hash = hashCode(countryName);
    const index = Math.abs(hash) % COUNTRY_COLORS.length;
    return COUNTRY_COLORS[index];
};

const InteractiveWorldMap = ({ countryData }) => {
  const mapRef = useRef(null);
  const [mapLoaded, setMapLoaded] = useState(false);

  // Load Leaflet CDN Resources
  useEffect(() => {
    if (window.L) {
      setMapLoaded(true);
      return;
    }

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.css';
    document.head.appendChild(link);

    const script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.js';
    script.async = true;
    script.onload = () => {
      setMapLoaded(true);
    };
    document.body.appendChild(script);
  }, []);

  // Initialize and Render Map
  useEffect(() => {
    if (!mapLoaded || !window.L || !mapRef.current) return;
    if (mapRef.current._leaflet_id) return;

    const map = window.L.map(mapRef.current, {
      center: [20, 0],
      zoom: 2,
      minZoom: 2,
      maxZoom: 18
    });

    window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map);

    const getCircleSize = (count) => {
      const baseSize = 300000; 
      const growthPerStudent = 100000; 
      const maxSize = 1500000; 
      
      return Math.max(baseSize, Math.min(maxSize, count * growthPerStudent));
    };

    // 3. UPDATED: Render circles using the generated unique color
    Object.values(countryData).forEach((data) => {
      const circle = window.L.circle([data.lat, data.lng], {
        color: '#fff',
        fillColor: data.color, // This now uses the unique color passed from the dashboard
        fillOpacity: 0.7,
        weight: 2,
        radius: getCircleSize(data.count)
      }).addTo(map);

      circle.bindPopup(`
        <div style="text-align: center; padding: 4px;">
          <strong>${data.name}</strong><br/>
          ${data.count} student${data.count !== 1 ? 's' : ''}
        </div>
      `);
    });

    return () => {
      map.remove();
    };
  }, [mapLoaded, countryData]);

  return (
    <div style={{ width: '100%' }}>
      <div 
        ref={mapRef} 
        style={{ 
          width: '100%', 
          height: '600px', 
          borderRadius: '8px', 
          overflow: 'hidden',
          background: '#f0f2f5',
          position: 'relative',
          zIndex: 1
        }}
      >
        {!mapLoaded && (
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            fontSize: '18px',
            color: '#666'
          }}>
            Loading map...
          </div>
        )}
      </div>
    </div>
  );
};

const EnhancedStudentsDashboard = () => {
  const [students, setStudents] = useState([]);
  const [courses, setCourses] = useState([]);
  const [courseCode, setCourseCode] = useState('all');
  const [activeTab, setActiveTab] = useState('1');

  // Fetch Courses
  useEffect(() => {
    GetCousesOfInstructror(setCourses);
  }, []);

  // Fetch Students
  useEffect(() => {
    StudentsEnrolled(setStudents, courseCode);
  }, [courseCode]);

  // Process students data
  const { processedStudents, countryDataObj, totalStats } = useMemo(() => {
    const processed = students.map(student => ({
      ...student,
      progress: Number(student.progress) || 0,
      questionAskedCount: student.questionAskedCount || 0,
      questionsAnsweredCount: student.questionsAnsweredCount || 0,
    }));

    const cData = {};
    processed.forEach(s => {
      const country = s.country || 'Unknown';
      if (COUNTRY_COORDINATES[country]) {
        if (!cData[country]) {
          // 4. ADDED: Assign the unique color during data processing
          cData[country] = { 
            name: country, // Added name so the popup renders properly
            count: 0, 
            color: getUniqueColor(country), // Store the color here
            ...COUNTRY_COORDINATES[country] 
          };
        }
        cData[country].count += 1;
      }
    });

    const stats = {
      total: processed.length,
      avgProgress: processed.length > 0 
        ? processed.reduce((acc, s) => acc + s.progress, 0) / processed.length 
        : 0,
      totalQuestions: processed.reduce((acc, s) => acc + s.questionAskedCount, 0)
    };

    return { processedStudents: processed, countryDataObj: cData, totalStats: stats };
  }, [students]);

  const headerCellStyle = {
    fontWeight: 'bold',
    fontSize: '14px'
  };

  return (
    <div className="enhanced-dashboard-content" style={{ padding: '24px', background: '#f0f2f5', minHeight: '100vh' }}>
      
      <style>{`
        @media (min-width: 992px) {
          .enhanced-dashboard-content {
            margin-left: 230px; 
          }
        }
      `}</style>

      <div style={{ marginBottom: '24px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <div>
            <h1 style={{ margin: 0, fontSize: '28px', fontWeight: 'bold', color: '#262626' }}>
              Students Dashboard
            </h1>
            <p style={{ margin: '4px 0 0 0', color: '#8c8c8c', fontSize: '14px' }}>
              Track and manage your student engagement
            </p>
          </div>
          <Select
            value={courseCode}
            onChange={setCourseCode}
            style={{ width: 250 }}
            size="large"
          >
            <Option value="all">All Courses</Option>
            {courses.map((course) => (
              <Option key={course.code} value={course.code}>{course.title}</Option>
            ))}
          </Select>
        </div>

        {/* Stats Cards */}
        <Row gutter={16} style={{ marginBottom: '24px' }}>
          <Col xs={24} sm={12} lg={6}>
            <Card>
              <Statistic
                title="Total Students"
                value={totalStats.total}
                prefix={<UserOutlined />}
                valueStyle={{ color: '#e01d20' }}
              />
            </Card>
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <Card>
              <Statistic
                title="Avg Progress"
                value={totalStats.avgProgress.toFixed(1)}
                suffix="%"
                prefix={<RiseOutlined />}
                valueStyle={{ color: '#52c41a' }}
              />
            </Card>
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <Card>
              <Statistic
                title="Questions Asked"
                value={totalStats.totalQuestions}
                prefix={<BookOutlined />}
                valueStyle={{ color: '#1890ff' }}
              />
            </Card>
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <Card>
              <Statistic
                title="Countries"
                value={Object.keys(countryDataObj).length}
                prefix={<GlobalOutlined />}
                valueStyle={{ color: '#722ed1' }}
              />
            </Card>
          </Col>
        </Row>
      </div>

      <Card style={{ borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
        <Tabs activeKey={activeTab} onChange={setActiveTab} size="large">
          <TabPane 
            tab={
              <span>
                <UserOutlined />
                Student List
              </span>
            } 
            key="1"
          >
            <MaterialTable
              title=""
              columns={[
                {
                  title: 'Profile',
                  field: 'profileImgTag',
                  headerStyle: headerCellStyle,
                  cellStyle: { width: '80px' }
                },
                {
                  title: 'Name',
                  field: 'studentName',
                  headerStyle: headerCellStyle,
                },
                {
                  title: 'Email',
                  field: 'email',
                  headerStyle: headerCellStyle,
                },
                {
                  title: 'Country',
                  field: 'country',
                  headerStyle: headerCellStyle,
                },
                {
                  title: 'Course',
                  field: 'courseTitle',
                  headerStyle: headerCellStyle,
                },
                {
                  title: 'Enrolled',
                  field: 'enrolledDate',
                  headerStyle: headerCellStyle,
                },
                {
                  title: 'Last Visit',
                  field: 'lastVisited',
                  headerStyle: headerCellStyle,
                },
                {
                  title: 'Progress',
                  field: 'progress',
                  headerStyle: headerCellStyle,
                  render: (rowData) => (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <div style={{
                        width: '100px',
                        height: '8px',
                        background: '#f0f0f0',
                        borderRadius: '4px',
                        overflow: 'hidden'
                      }}>
                        <div style={{
                          width: `${rowData.progress}%`,
                          height: '100%',
                          background: rowData.progress > 75 ? '#52c41a' : rowData.progress > 50 ? '#1890ff' : '#faad14',
                          transition: 'width 0.3s ease'
                        }} />
                      </div>
                      <span style={{ fontSize: '12px', fontWeight: 'bold' }}>
                        {Number(rowData.progress).toFixed(1)}%
                      </span>
                    </div>
                  )
                },
                {
                  title: 'Q Asked',
                  field: 'questionAskedCount',
                  headerStyle: headerCellStyle,
                },
                {
                  title: 'Q Answered',
                  field: 'questionsAnsweredCount',
                  headerStyle: headerCellStyle,
                },
                {
                  title: 'Action',
                  field: 'messageButton',
                  headerStyle: headerCellStyle,
                  render: (rowData) => (
                    <button
                      style={{
                        background: '#52c41a',
                        border: 'none',
                        padding: '8px 16px',
                        borderRadius: '6px',
                        color: 'white',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px',
                        fontSize: '14px',
                        transition: 'all 0.3s ease'
                      }}
                      onMouseOver={(e) => e.currentTarget.style.background = '#73d13d'}
                      onMouseOut={(e) => e.currentTarget.style.background = '#52c41a'}
                      onClick={() => window.location.href = "/communications/messages"}
                    >
                      <ForumIcon style={{ fontSize: '16px' }} />
                      Message
                    </button>
                  )
                }
              ]}
              data={processedStudents}
              options={{
                sorting: true,
                exportButton: true,
                pageSize: 10,
                pageSizeOptions: [5, 10, 20, 50],
                rowStyle: {
                  fontSize: '13px'
                },
                headerStyle: {
                  ...headerCellStyle,
                  backgroundColor: '#fafafa'
                }
              }}
            />
          </TabPane>
          
          <TabPane 
            tab={
              <span>
                <GlobalOutlined />
                Geographic Distribution
              </span>
            } 
            key="2"
          >
            <div style={{ padding: '24px 0' }}>
              <h3 style={{ marginBottom: '16px', fontSize: '18px', fontWeight: 'bold' }}>
                Student Distribution by Country
              </h3>
              <p style={{ marginBottom: '24px', color: '#8c8c8c' }}>
                Hover over the circles to see student counts in each country
              </p>
              
              {/* 5. UPDATED: Passed the formatted countryDataObj directly to the map */}
              <InteractiveWorldMap countryData={countryDataObj} />

              {/* Country List */}
              <div style={{ marginTop: '32px' }}>
                <h4 style={{ marginBottom: '16px', fontSize: '16px', fontWeight: 'bold' }}>
                  Top Countries
                </h4>
                <Row gutter={[16, 16]}>
                  {Object.entries(countryDataObj)
                    .sort(([, a], [, b]) => b.count - a.count)
                    .slice(0, 6)
                    .map(([country, data]) => (
                      <Col xs={24} sm={12} lg={8} key={country}>
                        {/* 6. UPDATED: Render the exact same data.color that the map is using */}
                        <Card size="small" style={{ borderLeft: `4px solid ${data.color}` }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <span style={{ fontWeight: '500' }}>{country}</span>
                            <Badge 
                              count={data.count} 
                              style={{ 
                                backgroundColor: data.color,
                                fontSize: '14px',
                                fontWeight: 'bold'
                              }} 
                            />
                          </div>
                        </Card>
                      </Col>
                    ))}
                </Row>
              </div>
            </div>
          </TabPane>
        </Tabs>
      </Card>
    </div>
  );
};

export default EnhancedStudentsDashboard;